//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SmokingSavedMoney',
  props: {
    datasets: {
      type: Array,
      default: null
    },
    price: {
      type: Number,
      default: null
    },
    startValue: {
      type: Number,
      default: null
    },
    currency: {
      type: String,
      default: ''
    }
  },
  computed: {
    sum: function sum() {
      var _this = this;

      if (!this.price || !this.startValue) {
        return null;
      } else {
        var s = 0;
        this.datasets.forEach(function (item) {
          if ('cigarettes' in item) {
            var count = _this.startValue - item.cigarettes;
            s = s + Math.round(count * _this.price * 100) / 100;
          }
        });
        return s;
      }
    }
  }
};